import _implicitStylesheets from "./sortOptions.css";
import _implicitScopedStylesheets from "./sortOptions.scoped.css?scoped=true";
import _wdsButton from "wds/button";
import _wdsRadioGroup from "wds/radioGroup";
import _wdsPopover from "wds/popover";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="visually-hidden${0}"${2}>${"t1"}</span>`;
const stc0 = {
  classMap: {
    "sort-button-container": true
  },
  key: 0
};
const stc1 = {
  "sort-button": true,
  "popover-trigger": true
};
const stc2 = {
  "data-id": "sortButton",
  "data-testid": "sortButton"
};
const stc3 = {
  classMap: {
    "sort-popover-content": true
  },
  key: 3
};
const stc4 = {
  "data-id": "sortOptions",
  "data-testid": "sortOptions"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, b: api_bind, c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element} = $api;
  const {_m0, _m1, _m2, _m3} = $ctx;
  return [api_element("div", stc0, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc1,
    attrs: stc2,
    props: {
      "variant": $cmp.variant,
      "size": $cmp.size,
      "name": "sortButton",
      "ariaExpanded": $cmp.displayTooltip,
      "ariaControls": api_scoped_id("sortOptions"),
      "icon": "sort",
      "iconPlacement": "end",
      "label": $cmp.sortButtonLabel
    },
    key: 1,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.toggleTooltip))
    }
  }), api_custom_element("wds-popover", _wdsPopover, {
    props: {
      "show": $cmp.displayTooltip,
      "ariaLabel": $cmp.sortButtonLabel,
      "popoverOrientation": $cmp.popoverOrientation,
      "hideCloseButton": true
    },
    key: 2,
    on: {
      "keydown": _m1 || ($ctx._m1 = api_bind($cmp.handleTooltipKeyboardEvent)),
      "close": _m2 || ($ctx._m2 = api_bind($cmp.closePopover))
    }
  }, [api_element("div", stc3, [api_static_fragment($fragment1, 5, [api_static_part(1, null, api_dynamic_text($cmp.labels.sort.tooltip))]), api_custom_element("wds-radio-group", _wdsRadioGroup, {
    attrs: stc4,
    props: {
      "value": $cmp.selectedOption,
      "options": $cmp.options,
      "multiple": "false"
    },
    key: 6,
    on: {
      "change": _m3 || ($ctx._m3 = api_bind($cmp.handleSortSelectionChange))
    }
  })])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7ieg7aajqqv";
tmpl.legacyStylesheetToken = "undefined-_sortOptions";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
